import styled from "@emotion/styled";

export const FlexSpacerDiv = styled.div`
    flex: 1 1 auto !important;
`;
